import React, { useEffect, useState } from 'react';

const Debug = (): JSX.Element => {
  const [showDebug, setShowDebug] = useState(false);
  const [showPrint, setShowPrint] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e): void | null => {
      if (e.key === 'g') {
        setShowDebug((prev) => !prev);
      }
      return null;
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  useEffect(() => {
    const root = document.getElementById('subaru-container');

    if (showPrint) {
      root.classList.add('SC__print');
    } else {
      root.classList.remove('SC__print');
    }
  }, [showPrint]);

  const activeDebugClass = showDebug ? 'active' : 'inactive';
  const activePrintClass = showPrint ? 'active' : 'inactive';

  if (process.env.NODE_ENV === 'production') return null;

  return (
    <>
      <button
        className={`debug-control ${activeDebugClass}`}
        onClick={() => setShowDebug(!showDebug)}>
        {showDebug ? 'hide layout boxes' : 'show layout boxes'}
      </button>
      {showDebug && (
        <div className={'fixed top-0 left-0 z-50 w-full pointer-events-none '}>
          <div className="box-border max-w-max-content-width w-full px-grid-padding mx-auto border-green-500">
            <div className="grid gap-grid-gap grid-cols-16">
              {[...new Array(16)].map((_, i) => (
                <div key={i} className={'h-screen bg-orange-300/30 w-full'} />
              ))}
            </div>
          </div>
        </div>
      )}
      <button
        className={`debug-control-print ${activePrintClass}`}
        onClick={() => setShowPrint(!showPrint)}>
        {showPrint ? 'hide print layout' : 'show  print layout'}
      </button>
    </>
  );
};

export default Debug;
